module.exports = __webpack_public_path__ + "img/8campus-20diplomes.1846fd1.jpg";